import React from "react";
import { FieldValues, UseFormRegister, UseFormWatch } from "react-hook-form";
import { userFormType } from "../ModalRegister";
import "./ModalRegisterForm.scss";
import { InputAddress } from "./RegisterInputs/InputAddress/InputAddress";
import { InputAgreement } from "./RegisterInputs/InputAgreement/InputAgreement";
import { InputBirthDay } from "./RegisterInputs/InputBirthDay/InputBirthDay";
import { InputCountry } from "./RegisterInputs/InputCountry/InputCountry";
import { InputCurrency } from "./RegisterInputs/InputCurrency/InputCurrency";
import { InputEmail } from "./RegisterInputs/InputEmail/InputEmail";
import { InputGender } from "./RegisterInputs/InputGender/InputGender";
import { InputLastName } from "./RegisterInputs/InputLastName/InputLastName";
import { InputLoyaltycode } from "./RegisterInputs/InputLoyaltycode/InputLoyaltycode";
import { InputName } from "./RegisterInputs/InputName/InputName";
import { InputPassport } from "./RegisterInputs/InputPassport/InputPassport";
import { InputPassword } from "./RegisterInputs/InputPassword/InputPassword";
import { InputPasswordConfirm } from "./RegisterInputs/InputPasswordConfirm/InputPasswordConfirm";
import { InputPhoneNumber } from "./RegisterInputs/InputPhoneNumber/InputPhoneNumber";
import { InputPromocode } from "./RegisterInputs/InputPromocode/InputPromocode";
import { InputSity } from "./RegisterInputs/InputSity/InputSity";
import { InputUserName } from "./RegisterInputs/InputUserName/InputUserName";

interface IModalRegisterForm {
  register: UseFormRegister<userFormType>
  watch: UseFormWatch<userFormType>;
  birthdayData: Date | null;
  setBirthdayData: React.Dispatch<React.SetStateAction<Date | null>>;
  selectedGender: number;
  setSelectedGender: React.Dispatch<React.SetStateAction<number>>;
  selectedCountryShort: string;
  setSelectedCountryShort: React.Dispatch<React.SetStateAction<string>>;
  countryCode: number;
  setCountryCode: React.Dispatch<React.SetStateAction<number>>;
  currenctSelect: string;
  setCurrenctSelect: React.Dispatch<React.SetStateAction<string>>;
}

const ModalRegisterForm = ({
  register,
  watch,
  birthdayData,
  setBirthdayData,
  selectedGender,
  setSelectedGender,
  selectedCountryShort,
  setSelectedCountryShort,
  countryCode,
  setCountryCode,
  currenctSelect,
  setCurrenctSelect,
}: IModalRegisterForm) => {
  return (
    <div className="entrance-form-content-section-bc">
      <InputName register={register} watch={watch} />
      <InputLastName register={register} watch={watch} />
      <InputUserName register={register} watch={watch} />
      <InputPassword register={register} watch={watch} />
      <InputPasswordConfirm register={register} watch={watch} />
      <InputBirthDay
        birthdayData={birthdayData}
        setBirthdayData={setBirthdayData}
      />
      <InputPassport register={register} watch={watch} />
      <InputEmail register={register} watch={watch} />
      <InputGender
        selectedGender={selectedGender}
        setSelectedGender={setSelectedGender}
      />
      <InputCountry
        selectedCountryShort={selectedCountryShort}
        setSelectedCountryShort={setSelectedCountryShort}
      />
      <InputSity register={register} watch={watch} />
      <InputAddress register={register} watch={watch} />
      <InputPhoneNumber
        countryCode={countryCode}
        setCountryCode={setCountryCode}
        register={register}
        watch={watch}
      />
      <InputCurrency
        currenctSelect={currenctSelect}
        setCurrenctSelect={setCurrenctSelect}
      />
      {/* <InputLoyaltycode /> */}
      <InputPromocode register={register} watch={watch} />
      <InputAgreement register={register}/>
    </div>
  );
};

export { ModalRegisterForm };
